'use client';
import { CatCheckboxField } from 'components/blocks-components';
import React from 'react';
import { useFbtContext } from '../fbt-context/fbt-context-provider';
import { getFBTSubTotal } from 'services/fbtItems/actions';

interface FbtCheckboxWrapperProps {
  partNumber: string;
  className?: string;
}

export const FbtCheckboxWrapper: React.FC<FbtCheckboxWrapperProps> = ({
  partNumber,
  className
}) => {
  const {
    fbtProductsWithPrice,
    setFbtProductsWithPrice,
    setSubTotal,
    currency,
    setIsFbtSubTotalLoading
  } = useFbtContext();

  const partPrice = React.useMemo(() => {
    return fbtProductsWithPrice?.find((item) => item.partNumber === partNumber);
  }, [fbtProductsWithPrice, partNumber]);

  const handleCheckboxChange = async (e) => {
    try {
      setIsFbtSubTotalLoading(true);
      const updatedFbtProducts = fbtProductsWithPrice.map((item) => ({
        ...item,
        isChecked:
          item.partNumber === partNumber ? e.detail.checked : item.isChecked
      }));

      const { subTotalResponse } = await getFBTSubTotal({
        currency,
        fbtParts: updatedFbtProducts,
        isHeadless: true
      });
      setSubTotal(subTotalResponse);
      setFbtProductsWithPrice(updatedFbtProducts);
    } catch (error) {
      setIsFbtSubTotalLoading(false);
    } finally {
      setIsFbtSubTotalLoading(false);
    }
  };

  return (
    <CatCheckboxField
      type="checkbox"
      id={partNumber}
      checked={partPrice?.isChecked || false}
      onBlCheckboxChange={handleCheckboxChange}
      disabled={!partPrice?.partLevelFlags?.isAddToCartEnabled}
      className={className}
      data-testid={`${partNumber}-checkbox`}
    />
  );
};
